<template>
  <div>
    <base-header type="gradient-primary" class="pb-7 pt-7 opacity-8">
      <div class="card shadow col-md-12 p-3">
        <div v-if="message">
          <base-alert :type="message.type" :dismissible="true">{{
            message.message
          }}</base-alert>
        </div>
        <div class="container">
          <div class="row">
            <button 
              @click="onShowModalUpload" 
              class="btn btn-primary ml-2"
            >
              <i class="fa fa-upload"></i> Import
            </button>
          </div>
        </div>
      </div>
    </base-header>
    <div class="container-fluid mt--6">
      <div class="card shadow">
        <div class="accordion p-3" role="tablist">
          <b-card no-body class="mb-1">
            <b-card-header header-tag="header" class="p-1" role="tab">
              <b-button
                block
                v-b-toggle.accordion-1
                variant="neutral"
                class="text-left"
                >Search
                <span class="when-opened ml-3">
                  <i class="fa fa-arrow-down" />
                </span>
                <span class="when-closed ml-3">
                  <i class="fa fa-arrow-right" />
                </span>
              </b-button>
            </b-card-header>
            <b-collapse
              id="accordion-1"
              visible
              accordion="my-accordion"
              role="tabpanel"
            >
              <b-card-body>
                <div class="mb-3 row">
                  <label class="col-sm-2 col-form-label form-control-label">
                    Brand Code
                  </label>
                  <div class="col-sm-2">
                    <b-form-select
                      id="input-3"
                      v-model="BrandCodeModel"
                      :options="brandCodeOption"
                      @change="onChangeModel('Region', true)"
                      class="mx-input"
                      required
                    ></b-form-select>
                  </div>
                </div>
                <div class="mb-3 row">
                  <label class="col-sm-2 col-form-label form-control-label">
                    Region
                  </label>
                  <div class="col-sm-2">
                    <b-form-select
                      id="input-3"
                      v-model="RegionModel"
                      :options="regionOption"
                      @change="onChangeModel('Province', true)"
                      class="mx-input"
                      required
                    ></b-form-select>
                  </div>
                </div>
                <div class="mb-3 row">
                  <label class="col-sm-2 col-form-label form-control-label">
                    Province
                  </label>
                  <div class="col-sm-2">
                    <b-form-select
                      id="input-3"
                      v-model="ProvinceModel"
                      :options="provinceOption"
                      @change="onChangeModel('City', true)"
                      class="mx-input"
                      required
                    ></b-form-select>
                  </div>
                </div>
                <div class="mb-3 row">
                  <label class="col-sm-2 col-form-label form-control-label">
                    City
                  </label>
                  <div class="col-sm-2">
                    <b-form-select
                      id="input-3"
                      v-model="CityModel"
                      :options="cityOption"
                      @change="onChangeModel('Load City', true)"
                      class="mx-input"
                      required
                    ></b-form-select>
                  </div>
                </div>
                <div class="mt-3 row">
                  <div class="col-sm-2 col-form-label form-control-label"></div>
                  <button
                    v-on:click="onResetFilter"
                    class="btn btn-neutral ml-2"
                  >
                    <i class="fa fa-times"></i> reset query
                  </button>
                </div>
              </b-card-body>
            </b-collapse>
          </b-card>
        </div>
        <vue-bootstrap4-table
          :rows="rows"
          :columns="columns"
          :config="config"
          :classes="classes"
          @on-select-row="onSelectRow"
          @on-unselect-row="onSelectRow"
          @refresh-data="onLoadData"
        >
        </vue-bootstrap4-table>
        <div class="overflow-auto mt-3">
          <nav>
            <ul class="pagination b-pagination justify-content-center">
              <li class="col-12 p-0 pl-2">
                <label class="ml-2">Go to page: </label>
                <b-form-select
                  size="sm"
                  class="col-1 ml-2 mr-2"
                  v-model="currentPage"
                  :options="arrayPages()"
                  required
                ></b-form-select>
                <b-button
                  v-if="currentPage != 1"
                  v-on:click="onLoadData(currentPage - 1)"
                  class="ml-3 mr-1 btn-sm btn-neutral"
                >
                  <i class="fa fa-less-than"></i>
                </b-button>
                <b-button
                  v-if="currentPage != totalPages"
                  v-on:click="onLoadData(currentPage + 1)"
                  class="ml-1 mr-3 btn-sm btn-neutral"
                >
                  <i class="fa fa-greater-than"></i>
                </b-button>

                <label class="ml-2">Show rows: </label>
                <b-form-select
                  size="sm"
                  class="col-1 ml-2 mr-2"
                  v-model="itemPerPage"
                  :options="ItemPerPageList"
                  required
                ></b-form-select>
                <label
                  >{{ itemPerPage * currentPage - itemPerPage + 1 }} -
                  {{
                    currentPage == totalPages
                      ? totalItems
                      : itemPerPage * currentPage
                  }}
                  of {{ totalItems }}
                </label>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </div>
    <modal :show.sync="showModalUpload" modal-classes="modal">
      <h3 slot="header" class="modal-title" id="modal-title-default">
        Upload data
      </h3>
      <form @submit.prevent>
        <base-input
          id="excelFile"
          input-classes="form-control text-white"
          class="mb-0"
          type="file"
          @change="onFileChange($event)"
        />
        <div v-if="excelSourceFile != null">
          <p class="pl-3">
            <small>{{ excelSourceFile.name }}</small>
          </p>
        </div>
      </form>
      <template slot="footer">
        <button
          class="btn btn-primary"
          v-on:click="submitValidationProcess"
          :disabled="excelSourceFile == null"
        >
          Run Procees
        </button>
      </template>
    </modal>
    <modal :show.sync="showModalCreate" modal-classes="modal-lg">
      <h3 slot="header" class="modal-title" id="modal-title-default">
        {{ this.titlePopup }} Province City
      </h3>
      <form @submit.prevent>
        <div class="row">
          <div class="col-lg-12">
            <label class="col-sm-12 col-form-label form-control-label">
              Brand Code
            </label>
              <b-form-select
                id="input-3"
                v-model="BrandCodeModel"
                :options="brandCodeOption"
                class="mx-input"
                required
              ></b-form-select>
          </div>
          <div class="col-lg-12">
            <base-input
              label="Region"
              input-classes="form-control"
              v-model="RegionModel"
              type="text"
            />
          </div>
          <div class="col-lg-12">
            <base-input
              label="Province"
              input-classes="form-control"
              v-model="ProvinceModel"
              type="text"
            />
          </div>
          <div class="col-lg-12">
            <base-input
              label="City"
              input-classes="form-control"
              v-model="CityModel"
              type="text"
            />
          </div>
        </div>
      </form>
      <template slot="footer">
        <base-button
          type="link"
          class="ml-auto"
          @click="showModalCreate = false"
          >Close/ Cancel
        </base-button>
        <button
          class="btn btn-primary"
        >
          Submit
        </button>
      </template>
    </modal>
  </div>
</template>
<script>
import VueBootstrap4Table from "vue-bootstrap4-table";
import api_loyalty from "../api/api";
import "vue2-datepicker/index.css";

export default {
  name: "configList",
  data() {
    return {
      is_allowed_approve: false,
      ShowReValidateModal: false,
      excelSourceFile: null,
      timeFilter: [],
      selectedItems: [],
      showModalUpload: false,
      showActionEdit: false,
      showModalCreate: false,
      BrandCodeModel: "PHChe",
      RegionModel: "",
      ProvinceModel: "",
      CityModel: "",
      brandCodeOption: [],
      regionOption: [],
      provinceOption: [],
      cityOption: [],
      totalItems: 0,
      totalPages: 0,
      itemPerPage: 50,
      ItemPerPageList: [50, 100, 500, 1000, 5000],
      currentPage: 1,
      filter: {
        brandCode: "",
        regionName: "",
        provinceName: "",
        cityName: "",
      },
      allTransaction: [],
      titlePopup: "Create",
      message: null,
      rows: [],
      columns: [
        {
          label: "Brand Code",
          name: "brandCode",
          row_text_alignment: "text-left",
        },
        {
          label: "region name",
          name: "regionName",
          sort: true,
          row_text_alignment: "text-left",
        },
        {
          label: "province name",
          name: "provinceName",
          sort: true,
        },
        {
          label: "city name",
          name: "cityName",
          sort: true,
        },
      ],
      config: {
        pagination: false,
        pagination_info: false,
        num_of_visibile_pagination_buttons: 8,
        per_page: this.itemPerPage ? this.itemPerPage : 50,
        checkbox_rows: false,
        highlight_row_hover: true,
        rows_selectable: false,
        multi_column_sort: true,
        card_mode: false,
        selected_rows_info: false,
        global_search: {
          visibility: false,
        },
        show_refresh_button: false,
        show_reset_button: false,
      },
      classes: {
        table: "table-striped table-bordered",
        row: {
          "my-row my-row2": true,
          "function-class": function (row) {
            return row.id == 1;
          },
        },
      },
    };
  },
  created() {
    this.mappingRole();
    this.is_allowed_approve =
      this.$store.getters.isCheAdmin ||
      this.$store.getters.isFortuneAdmin ||
      this.$store.getters.isLoginUserAdmin;
    this.fetchData(this.BrandCodeModel, this.RegionModel, this.ProvinceModel, "Region", false);
  },
  methods: {
    async submitValidationProcess() {
      try {
        this.showModalUpload = false;
        var base64String = "";
        await this.getBase64(this.excelSourceFile).then(
          data => {

            base64String = data;
          }
        );
        this.message = {
          message:
            "please do not refresh or close this page. Refresh/close this page will canceling the process.",
          type: "warning",
        };

        let response = await api_loyalty.UploadProvinceCity(
          base64String,
          this.BrandCodeModel,
        );
        if (response.isSuccess) {
          this.message = {
            message:
              "complete import data",
            type: "success",
          };
        } else {
          this.message = {
            message:
              "failed to import data",
            type: "danger",
          };
        }
      } catch (error) {
        this.message.type = "danger";
        this.message.message = error;
      }
    },
    arrayPages() {
      var result = [];
      for (let index = 0; index < this.totalPages; index++) {
        result.push({ text: index + 1, value: index + 1 });
      }
      return result;
    },
    onResetFilter() {
      this.BrandCodeModel = "";
      this.RegionModel = "";
      this.ProvinceModel = "";
      this.CityModel = "";
      let momNow = this.$moment(new Date().toUTCString());
      this.filter.to_date = momNow.add(1, "days").format("YYYY-MM-DD");
      this.filter.from_date = momNow.add(-1, "months").format("YYYY-MM-DD");
      this.onLoadData();
    },
    async onLoadData() {
      api_loyalty.GetAllProvinceCity(this.BrandCodeModel, this.RegionModel, this.ProvinceModel, this.CityModel)
        .then((data) => {
          try {
            if(data.isSuccess) {
              this.rows = data.data;
            } 
          } catch (e) {
            console.log(e);
          }
        });
    },
    onFileChange(e) {
      var files = e.target.files || e.dataTransfer.files;
      this.excelSourceFile = files[0];
    },
    onDateFilterSubmit(value) {
      let momStart = this.$moment(new Date(value[0])).format("YYYY-MM-DD");
      let momEnd = this.$moment(new Date(value[1])).format("YYYY-MM-DD");
      this.filter.from_date = momStart;
      this.filter.to_date = momEnd;
    },
    onSelectRow(payload) {
      this.showActionEdit = true;
      this.showActionDelete = true;
      this.selectedItems = payload.selected_items;
      if (payload.selected_items.length == 0) {
        this.showActionEdit = false;
        this.showActionDelete = false;
      }
      if (payload.selected_items.length > 1) {
        this.showActionEdit = false;
      }
    },
    onEditRow() {
      this.RegionModel = this.rows.filter(
        (x) => x.id === this.selectedItems[2].id
      )[0];
      this.showModalCreate = true;
      this.titlePopup = "Update";
    },
    onDeleteRow() {
      this.showConfirmationModal = false;
    },
    mappingRole() {
      let isChe = this.$store.getters.roleMappingData.some(object =>
        object.role.toLowerCase().includes('phche') &&
        object.menu.toLowerCase().includes('provincecity')
      );
      let isFortune = this.$store.getters.roleMappingData.some(object =>
        object.role.toLowerCase().includes('phft') ||
        object.role.toLowerCase().includes('fortune') &&
        object.menu.toLowerCase().includes('provincecity')
      );
      let isAdministrator = this.$store.getters.isLoginUserAdmin;
      this.brandCodeOption = [];
      if (isAdministrator || isChe) {
        this.brandCodeOption.push({ text: "Chesterfield", value: "PHChe" });
        this.BrandCodeModel = this.ChartBrandCodeModel = "PHChe";
        this.watch_brand_code = "PHChe";
      }

      if (isAdministrator || isFortune) {
        this.brandCodeOption.push({ text: "Fortune", value: "PHFortune" });
        this.BrandCodeModel = this.ChartBrandCodeModel = "PHFortune";
        this.watch_brand_code = "PHFortune";
      }
    },
    onChangeModel(value, optional) {
      this.resetModelsAndOptions(value, optional);
      this.fetchData(this.BrandCodeModel, this.RegionModel, this.ProvinceModel, value);
    },
    async fetchData(brandCode, regionName, provinceName, value) {
      api_loyalty.GetRegionProvinceCity(brandCode, regionName, provinceName, value)
        .then((data) => {
          try {
            if(data.isSuccess) {
              switch (value) {
                case "Region":
                  this.regionOption = data.data;
                  this.onLoadData();
                  break;
                case "Province":
                  this.provinceOption = data.data;
                  this.onLoadData();
                  break;
                case "City":
                  this.cityOption = data.data;
                  this.onLoadData();
                  break;
                case "Load City":
                  this.onLoadData();
                  break;
                default:
                  this.brandCodeOption = data.data;
                  break;
              }
            }
          } catch (e) {
            console.log(e);
          }
        });
    },
    resetModelsAndOptions(value, optional) {
      switch (value) {
        case "Region":
          if (optional) {
            this.RegionModel = null;
            this.regionOption = null;
            this.ProvinceModel = null;
            this.provinceOption = null;
            this.CityModel = null;
            this.cityOption = null;
          } else {
            this.ProvinceModel = null;
            this.provinceOption = null;
            this.CityModel = null;
            this.cityOption = null;
          }
          break;
        case "Province":
          this.ProvinceModel = null;
          this.provinceOption = null;
          this.CityModel = null;
          this.cityOption = null;
          break;
        case "City":
          break;
        case "Load City":
          break;
        default:
          this.RegionModel = null;
          this.regionOption = null;
          this.ProvinceModel = null;
          this.provinceOption = null;
          this.CityModel = null;
          this.cityOption = null;
          this.onLoadData();
          break;
      }
    },
    async getBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
      });
    },
    onShowModalUpload() {
      this.showModalUpload = true;
      this.excelSourceFile = null;
    }
  },
  components: {
    VueBootstrap4Table,
  },
  watch: {
    itemPerPage: function () {
      this.config.per_page = this.itemPerPage;
      this.onLoadData();
    },
    currentPage: function () {
      this.onLoadData(this.currentPage);
    },
  },
};
</script>
<style></style>
